// extracted by mini-css-extract-plugin
export default {"EmptyStatePrompt":"EmptyStatePromptQhAfTGAFyhPz","EmptyStatePrompt-label":"EmptyStatePrompt-label3uUz2IMZc0nv","EmptyStatePrompt-icon":"EmptyStatePrompt-icon3vffq3X781Gb"};